import { Component, OnInit, OnDestroy } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

// other libraries;
import { LangChangeEvent } from "@ngx-translate/core";


// services
import { CredentialService } from "../../../../services/credential.service";

// models
import { ParticipantCredential } from "../../../../models/participant-credential";

// extends
import { BasePage } from "../../../base";
import { Participant } from 'src/app/models/participant';

@Component({
    selector: 'app-credentials',
    templateUrl: './credentials.page.html',
    styleUrls: ['./credentials.page.scss'],
})
export class CredentialsPage extends BasePage implements OnInit {

    public credentials: Array<ParticipantCredential> = [];

    public participant: Participant = new Participant();

    public loading: boolean = true;

    public countSizes = {
        2: [1, 2],
        3: [1, 2, 3],
        4: [1, 2, 3, 4],
        5: [1, 2, 3, 4, 5]
    };

    public showSharing: boolean = false;

    public sharingOptions: Array<string> = ['linkedin',
        'twitter',
        'whatsapp',
        'facebook',
        'email',
        'copy'];

    private token: string;

    constructor(
        private metaService: Meta,
        private titleService: Title,
        public route: ActivatedRoute,
        public credentialService: CredentialService
    ) {
        super();

        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.userLang = event.lang;
        });
    }

    ngOnInit() {
        // load credential, by token, which is id + '-' + token
        const token = this.route.snapshot.params['token'];

        if (!!token) {
            this.token = token;
            this.refresh();
        } else {
            // redirect to login in case of not existing params
        }
    }

    refresh($event?) {
        this.credentialService.getParticipantCredentialsByToken(this.token).subscribe(
            (data: { participant: Participant, credentials: Array<ParticipantCredential> }) => {

                this.credentials = data.credentials.map((c) => new ParticipantCredential(c));
                this.participant = new Participant(data.participant);

                // hide loading
                if ($event) {
                    $event.target.complete();
                } else {
                    this.loading = false;
                }

            }, (error) => {
                this.loading = false;
                const data = error.error;
                this.overlayService.showError(data.message);
                // redirect to login
                this.router.navigate(['login']);
            });
    }

    openPublicDetail(credential: ParticipantCredential) {
        // window.location.href = location.origin + '/credential/' + credential.id + '-' + credential.token;
        this.router.navigate(['/credential/' + credential.id + '-' + credential.token])
    }

    showShare(credential: ParticipantCredential) {
        credential.showSharing = true;
        this.showSharing = true;
        return false;
    }

    /**
     * hide sharing
     *
     */
    hideSharing(): void {
        this.showSharing = false;
        this.credentials.forEach((c) => {
            c.showSharing = false;
        })
    }

    share(type: string, credential: ParticipantCredential, badge: boolean = true) {

        credential.showSharing = false;
        this.showSharing = false;

        let link = location.origin + '/credential/' + credential.id + '-' + credential.token + '?locale=' + this.userLang + (badge ? '&badge=true' : '');

        let r = {
            link: encodeURIComponent(link),
            text: encodeURIComponent(this.translate.instant('CREDENTIAL_WALLET_SHARE_TEXT')),
            subject: encodeURIComponent(this.translate.instant('CREDENTIAL_WALLET_SHARE_SUBJECT')),
        };

        let windowSetting = `toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=500`;

        if (this.plt.sizeMd) {
            windowSetting = `toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes`;
        }

        switch (type) {
            case 'facebook':
                window.open('https://www.facebook.com/sharer/sharer.php?u=' + r.link, 'targetWindow', windowSetting);
                break;
            case 'twitter':
                window.open('https://twitter.com/intent/tweet?url=' + r.link + '&text=' + r.text, 'targetWindow', windowSetting);
                break;
            case 'linkedin':
                window.open('https://www.linkedin.com/shareArticle/?url=' + r.link + '&title=' + r.subject + '&summary=' + r.text, 'targetWindow', windowSetting);
                break;
            case 'google':
                window.open('https://plus.google.com/share?url=' + r.link, 'targetWindow', windowSetting);
                break;
            case 'whatsapp':
                window.open('https://api.whatsapp.com/send?phone=&text=' + r.text + '%0d%0a' + r.link + '&source=&data=', 'targetWindow', windowSetting);
                break;
            case 'xing':
                window.open('https://www.xing.com/spi/shares/new?url=' + r.link, 'targetWindow', windowSetting);
                break;
            case 'email':
                if (this.plt.is('android')) {
                    window.open('mailto:?subject=' + r.subject + '&body=' + r.text + encodeURI('\n\n') + r.link, '_top');
                } else {
                    window.open('mailto:?subject=' + r.subject + '&body=' + r.text + encodeURI('\n\n') + r.link, '_blank');
                }
                break;
            case 'copy':
                this.plt.copyToClipboard(link);
                this.showSuccess(this.translate.instant('LINK_COPIED'));
                break;
        }
    }


}
